import type { FC, ReactElement } from "react";
import type { CarReservationCardProps } from "@apac/components/cars";
import { ProductType } from "@b2bportal/core-types";
import { ReservationStateEnum } from "@b2bportal/ground-api";
import { TripsCard } from "@tenant/trips";
import clsx from "clsx";
import { useCarReservationCard } from "./useCarReservationCard";
import { TripsReservationStatusPill } from "@/components";

export const CarReservationCard: FC<
  CarReservationCardProps & {
    tag?: ReactElement | string;
  }
> = ({ itinerary, className, selectItinerary, tag }) => {
  const { text } = useCarReservationCard(itinerary.reservation);
  const isCancelled =
    itinerary.reservation.state.ReservationState ===
    ReservationStateEnum.Cancelled;
  const dateLabel = `${text.pickupDate} - ${text.dropOffDate}`;
  const dateDisplay = isCancelled ? (
    <span style={{ textDecoration: "line-through" }}>{dateLabel}</span>
  ) : (
    dateLabel
  );
  const status = (
    <TripsReservationStatusPill
      variant={ProductType.CARS}
      status={itinerary.reservation.state.ReservationState}
    />
  );
  const carImage = itinerary.reservation.vehicle?.images?.original;

  return (
    <TripsCard
      className={clsx(className)}
      title={text.title}
      onClick={selectItinerary}
      confirmationCode={text.confirmation}
      description={text.location}
      date={dateDisplay}
      image={carImage}
      status={status}
      constrainImage
    />
  );
};
